<template>
  <div class="anniversary" v-if="screenWidth > 900">
    <div class="banner">
      <img src="@/assets/images/anniversary/p00.jpg" alt="" />
      <div class="toHome" @click="toHome">
        <img src="@/assets/images/anniversary/btn_top.png" alt="" />
      </div>
    </div>
    <div class="activity">
      <div class="jump">
        <img
          src="@/assets/images/anniversary/p01.jpg"
          @click.stop="copyCode"
          alt=""
        />
      </div>
      <div class="jump" ref="gift">
        <img src="@/assets/images/anniversary/p02.jpg" alt="" />
      </div>
      <div class="jump">
        <img src="@/assets/images/anniversary/p03.jpg" alt="" />
      </div>
      <div class="jump">
        <img src="@/assets/images/anniversary/p04.jpg" alt="" />
      </div>
      <div class="jump">
        <img src="@/assets/images/anniversary/p05.jpg" alt="" />
      </div>
      <div class="jump">
        <img src="@/assets/images/anniversary/p06.jpg" alt="" />
      </div>
      <div class="jump">
        <img src="@/assets/images/anniversary/p07.jpg" alt="" />
      </div>
      <div :class="['nav', isFixed ? 'isFixed' : 'isNormal']">
        <div class="nav-home" @click="toHome">
          <img src="@/assets/images/anniversary/00.png" alt="" />
        </div>
        <div class="nav-box">
          <div class="btn-box">
            <div
              class="item"
              v-for="(item, index) in navActive"
              :key="index"
              @click="toAnchor(index)"
            >
              <img :src="item.img" alt="" v-if="subindex === index" />
            </div>
          </div>
          <img src="@/assets/images/anniversary/nav.png" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="mobile" v-else>
    <img src="@/assets/images/anniversary/pm00.jpg" alt="" />
    <img src="@/assets/images/anniversary/pm01.jpg" alt="" />
    <img src="@/assets/images/anniversary/pm02.jpg" alt="" />
    <div class="goHome" @click="toHome">
      <img src="@/assets/images/anniversary/btn_m.png" alt="" />
    </div>
  </div>
</template>
<script>
import { useScreenState } from "../../store";
import { message } from "../../components/globalMessage";
export default {
  name: "anniversary",
  data() {
    return {
      subindex: -1,
      isFixed: false,
      screenState: useScreenState(),
      navActive: [
        {
          img: require("@/assets/images/anniversary/01.png"),
        },
        {
          img: require("@/assets/images/anniversary/02.png"),
        },
        {
          img: require("@/assets/images/anniversary/03.png"),
        },
        {
          img: require("@/assets/images/anniversary/04.png"),
        },
        {
          img: require("@/assets/images/anniversary/05.png"),
        },
        {
          img: require("@/assets/images/anniversary/06.png"),
        },
        {
          img: require("@/assets/images/anniversary/07.png"),
        },
      ],
      scroll: 0,
      timer: "",
      screenWidth: document.body.clientWidth,
    };
  },
  mounted() {
    let that = this;
    window.addEventListener("scroll", this.handelScroll, false);
    console.log(document.body.clientWidth)
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  unmounted() {
    window.removeEventListener("scroll", this.handelScroll);
  },
  methods: {
    toHome() {
      this.$router.push("/home");
    },
    handelScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      let jump = document.querySelectorAll(".jump");
      jump.forEach((item, index) => {
        if (item.offsetTop < this.scroll) {
          this.subindex = index;
        }
      });
      if (this.scroll > this.$refs.gift.offsetTop - 300) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    toAnchor(index) {
      this.subindex = index;
      let jump = document.querySelectorAll(".jump");
      let total = jump[index].offsetTop;
      document.body.scrollTop = total;
      document.documentElement.scrollTop = total + 100;
      window.pageYOffset = total;
    },
    copyCode() {
      let text = "HAPPY1Y";
      let input = document.createElement("input");
      input.setAttribute("value", text);
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      message.success("序號已複製到剪切板", this);
    },
  },
};
</script>
<style lang="scss" scoped>
.anniversary {
  width: 100%;
  .banner {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .toHome {
      position: absolute;
      top: 0;
      right: 10%;
      cursor: pointer;
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
  .activity {
    width: 100%;
    position: relative;
    div {
      width: 100%;
      img {
        width: 100%;
        display: block;
      }
    }
    .isNormal {
      position: absolute;
      top: 0;
      left: 0;
    }
    .isFixed {
      position: fixed;
      top: 0;
      left: 0;
    }
    .nav {
      width: 20%;
      &-home {
        width: 100%;
        cursor: pointer;
        img {
          width: 100%;
          display: block;
        }
      }
      &-box {
        width: 100%;
        position: relative;
        img {
          width: 100%;
          display: block;
        }
        .btn-box {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 8;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
          box-sizing: border-box;
          justify-content: space-between;
          grid-gap: 15px;
          padding: 10% 0;

          div {
            cursor: pointer;
            border-bottom: none;
            height: 10%;
            display: flex;
            align-items: center;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
}
.mobile {
  width: 100%;
   img {
    width: 100%;
    height: auto;
    display: block;
  }
  .goHome {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}
</style>
